import { useEffect, useMemo, useState } from "react";

const YoutubePlayer = ({ videoId, playerClass }) => {
  const [YouTube, setYouTube] = useState(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    import("react-youtube").then(mod => {
      setYouTube(() => mod.default);
    });
  }, []);

  const opts = useMemo(() => ({
    width: "100%",
    height: "100%",
    playerVars: {
      autoplay: 0,
      controls: 1,
      rel: 0,
      modestbranding: 1,
    },
  }), []);

  /* ---------- SERVER + FIRST PAINT ---------- */
  if (!mounted) {
    return (
      <div className={playerClass}>
        <img
          src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
          alt="Video thumbnail"
          width="100%"
          height="100%"
          loading="eager"
        />
      </div>
    );
  }

  /* ---------- CLIENT ---------- */
  if (!YouTube) return null;

  return (
    <div className={playerClass}>
      <YouTube videoId={videoId} opts={opts} />
    </div>
  );
};

export default YoutubePlayer;